import { Grid, Tooltip } from "antd"
import React from "react"

import { IS_PROD } from "../constants/dev"

const { useBreakpoint } = Grid

export function MediaIndicator() {
  if (IS_PROD) return null

  return <Indicator />
}

const Indicator = () => {
  const screens = useBreakpoint()
  const antScreen = Object.entries(screens)
    ?.reverse()
    .find(([_, value]) => value)?.[0]

  return (
    <div className="fixed bottom-0.5 left-0.5 z-50 flex flex-col items-center justify-center gap-1">
      <Tooltip placement="right" title="Tailwind">
        <div className="flex items-center justify-center rounded-full bg-blue-500 p-1 size-8 font-mono text-xs text-white">
          <div className="block sm:hidden">xs</div>
          <div className="hidden sm:block md:hidden lg:hidden xl:hidden xxl:hidden">
            sm
          </div>
          <div className="hidden md:block lg:hidden xl:hidden xxl:hidden">
            md
          </div>
          <div className="hidden lg:block xl:hidden xxl:hidden">lg</div>
          <div className="hidden xl:block xxl:hidden">xl</div>
          <div className="hidden xxl:block">xxl</div>
        </div>
      </Tooltip>
      <Tooltip placement="right" title="Antd">
        <div className="flex items-center justify-center rounded-full bg-red-500 p-2 font-mono text-xs text-white">
          <div>{antScreen}</div>
        </div>
      </Tooltip>
    </div>
  )
}
